import { PageAboutMe } from './PageAboutMe';

export default PageAboutMe;
